import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Packages
import MaskedTextInput from 'react-text-mask';

class MaskedFormInput extends Component {
  static propTypes = {
    // Required
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,

    //Optional
    error: PropTypes.string,
    label: PropTypes.string,
    optionalClasses: PropTypes.string,
    selectOptions: PropTypes.array,
    children: PropTypes.node,
    placeholder: PropTypes.string,
    showError: PropTypes.bool,
    disabled: PropTypes.bool,
  }

  renderLabel(label) {
    return label
    ? (
        <label>{label}</label>
      )
    : ''
  }

  renderErrorMessage = (errorMessage) => {
    return errorMessage ? (
      <div className="input-error-message">
        {errorMessage}
      </div>
    ) : '';
  }

  render() {
    const {
      label,
      name,
      type,
      value,
      placeholder,
      placeholderChar,
      onChange,
      errorMessage,
      showError,
      optionalClasses,
      guide,
      mask,
      disabled,
    } = this.props;

    return (
      <div
        className={`input-container${optionalClasses ? ' ' + optionalClasses : ''}${errorMessage ? ' error' : ''}`}
      >
        {this.renderLabel(label)}
        <MaskedTextInput
          guide={guide}
          mask={mask}
          name={name}
          placeholder={placeholder}
          placeholderChar={placeholderChar}
          type={type}
          value={value}
          onChange={onChange}
          disabled={disabled}
        />
        {showError && this.renderErrorMessage(errorMessage)}
      </div>
    )
  }
}


export default MaskedFormInput;



// WEBPACK FOOTER //
// ./src/components/Global/Forms/MaskedFormInput.js